import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import Schedule from './schedule';
import logo from './logo.png';
import NavMenu from './NavMenu';
import ContactBar from './ContactBar';
import Booking from './Booking';
import Simulator from './Simulator';
import Contact from './Contact';
import EarlyAccess from './EarlyAccess';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

//  const [linkNameInProgress, setLinkNameInProgress] = useState("vfrnr");
// const [linkName, setLinkName] = useState("vfrnr");

function calendyInlay() {
  return (
    <div className="calendly-inline-widget" data-url={"https://calendly.com/" + "vfrnr" + "?primary_color=00ff00&text_color=ffff00&background_color=038df6"} style={{ minWidth: "30%", height: "100vh", zIndex: 1000 }}>
      <script data-allow="payment" type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
    </div>
  )
}



root.render(
  <React.StrictMode>
    <BrowserRouter>
      <div className="App">
        <div className="applicationWrapper">
          {/* <div className="navMenu">
            <button onClick={() => globalNavigation("schedule")}>Schedule</button>
          </div> */}

          <div className="wrapper-1">
            <NavMenu></NavMenu>
            <>
              <Routes>
                <Route path="/" element={<App></App>}></Route>
                {/* <Route path="/schedule" element={<Schedule></Schedule>}></Route>
                <Route path="/reservation" element={<Booking></Booking>}></Route>
                <Route path="/simulator" element={<Simulator></Simulator>}></Route> */}
                <Route path="/earlyAccess" element={<EarlyAccess></EarlyAccess>}></Route>
                <Route path="/contact" element={<Contact></Contact>}></Route>
              </Routes>
            </>
            <ContactBar></ContactBar>
          </div>

          {/* <div className="wrapper-2">
            {calendyInlay()}
          </div> */}
        </div>
      </div>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
